import type { Element } from '@xmldom/xmldom'

export interface DefaultProps {
	cid: string|null,
	subconceptCid: string|null,
}

export const applyDefaultCid = (node: Element, defaultProps: DefaultProps) => {
	if((!node.hasAttribute('cid')) && defaultProps.cid !== null) {
		node.setAttribute('cid', defaultProps.cid)
	}
}

export const applyDefaultSubconceptCid = (node: Element, defaultProps: DefaultProps) => {
	if((!node.hasAttribute('subconceptCid')) && defaultProps.subconceptCid !== null) {
		node.setAttribute('subconceptCid', defaultProps.subconceptCid)
	}
}
